@if (turn) {
  <div class="turn-card" [class.combined]="turn.CombinedTurn">
    <div class="turn-main">
      <div class="turn-icon">
        <span class="turn-svg" aria-label="turn"
          [appSvgRecolor]="'assets/icons/default/turn/' + turn.Icon[0]"
          [recolorGradient]="baseGradientStops"></span>
        @if (turn.CombinedTurn) {
          <div class="second-turn-icon" data-testid="turn-second-turn">
            <span class="turn-svg" aria-label="second turn"
              [appSvgRecolor]="'assets/icons/default/turn/' + turn.Icon[1]"
              [recolorGradient]="baseGradientStops"></span>
          </div>
        }
      </div>
      <div class="turn-distance">
        <div [hidden]="!showMetricKMeter(turnDistance)">
          <span class="turn-distance-value">{{ turnDistance / 1000 | turnValueIntegerThousands }}</span>
          <span class="turn-distance-unit">km</span>
        </div>
        <div [hidden]="!showMetricMeter(turnDistance)">
          <span class="turn-distance-value">{{ turnDistance | turnValueInteger }}</span>
          <span class="turn-distance-unit">m</span>
        </div>
        <div [hidden]="!showImperialMile(turnDistance)">
          <span class="turn-distance-value">{{ turnDistance * 0.000621371192 | turnValueIntegerThousands }}</span>
          <span class="turn-distance-unit">mi</span>
        </div>
        <div [hidden]="!showImperialYard(turnDistance)">
          <span class="turn-distance-value">{{ turnDistance * 1.0936133 | turnValueInteger }}</span>
          <span class="turn-distance-unit">yd</span>
        </div>
      </div>
    </div>
    @if (showLanes && turn.LaneInfo && turn.LaneInfo.length > 1) {
      <div class="turn-lanes" data-testid="turn-lanes-panel">
        @for (lane of turn.LaneInfo; track $index; let i = $index) {
          <div class="turn-lane" [class.highlighted]="lane.Highlighted"
            [attr.data-testid]="'turn-lane-item-' + i">
            <div class="turn-lane-images">
              @for (image of lane.Images; track image) {
                <img class="turn-lane-img" [src]="'assets/icons/dark/lane_info/' + image" alt="" />
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}
